import React, { useState } from "react";
import styled, { css } from "styled-components";

import Icon from "@/public/core/components/Icon";
import { Link } from "react-router-dom";
import { Medium14 } from "@/dashboard/core/components/Text";
import { sanitizeAttribute } from "@/utils/sanitize";
import theme from "@/styles/theme";

const ContainerStyle = css`
  cursor: pointer;
  padding: ${theme.spacing.unit * 1}px;

  display: flex;
  align-items: center;
  column-gap: ${theme.spacing.unit * 1}px;

  min-height: 40px;
  box-sizing: border-box;

  border-radius: 4px;

  ${({ $isSelected, $isHighlighted }) => {
    if ($isSelected) {
      return `
        color: ${theme.colors.green};
        background-color: ${theme.colors.gray50};
      `;
    } else if ($isHighlighted) {
      return `
        color: ${theme.colors.green};
      `;
    } else {
      return `
        color: ${theme.colors.gray700};
        background-color: ${theme.colors.white};

        &:hover {
          color: ${theme.colors.gray800};
          background-color: ${theme.colors.gray25};
        }
      `;
    }
  }}
`;

const Container = styled.div`
  ${ContainerStyle}
`;

const LinkContainer = styled(Link)`
  ${ContainerStyle}
`;

const IconPlaceholder = styled.div`
  width: 16px;
  height: 16px;
`;

const SidebarNavItem = ({
  className,
  path,
  onClick,
  icon,
  title,
  isSelected,
  isHighlighted,
  onMouseEnter,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    if (onMouseEnter) {
      onMouseEnter();
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  let iconColor = theme.colors.gray700;
  if (isHovered) {
    iconColor = theme.colors.gray800;
  }
  if (isSelected || isHighlighted) {
    iconColor = theme.colors.green;
  }

  if (onClick) {
    return (
      <Container
        className={className}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {icon ? (
          <Icon
            src={icon}
            size={16}
            iconColor={iconColor}
            alt={`${sanitizeAttribute(title)} Icon`}
          />
        ) : (
          <IconPlaceholder />
        )}
        <Medium14>{title}</Medium14>
      </Container>
    );
  }

  return (
    <LinkContainer
      className={className}
      to={path}
      $isSelected={isSelected}
      $isHighlighted={isHighlighted}
      // data-testing={"sidebar-" + path.slice(1)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {icon ? (
        <Icon
          src={icon}
          size={16}
          iconColor={iconColor}
          alt={`${title} Icon`}
        />
      ) : (
        <IconPlaceholder />
      )}
      <Medium14>{title}</Medium14>
    </LinkContainer>
  );
};

export default SidebarNavItem;
